export const routeConfig = {
  main: [
    { path: "/", element: "Home", isSecure: false },
    { path: "cart", element: "Cart", isSecure: true },
    { path: "checkout", element: "Checkout", isSecure: true },
    { path: "checkout/:productId", element: "Checkout", isSecure: true },
    { path: "favourite", element: "Favourite", isSecure: true },
    { path: "category/:id", element: "Category", isSecure: false },
    { path: "profile", element: "Profile", isSecure: true },
    { path: "product/:productId", element: "ProductDetails", isSecure: false },
    { path: "orders", element: "Order", isSecure: true },
    { path: "signup", element: "Signup", isSecure: false },
    { path: "search", element: "Search", isSecure: false },
    { path: "auth", element: "Auth", isSecure: false },
    { path: "address", element: "Address", isSecure: true },
    { path: "auth/otp", element: "OTP", isSecure: false },
    { path: "auth/signup", element: "Signup", isSecure: false },
  ],
  information: [
    { path: "privacy-policy", element: "Privacy", isSecure: false },
    { path: "terms-of-use", element: "Terms", isSecure: false }
  ]
};
